import { render, staticRenderFns } from "./ReviewRetireMergeConfirmation.vue?vue&type=template&id=55bfa3a0&scoped=true&"
import script from "./ReviewRetireMergeConfirmation.vue?vue&type=script&lang=js&"
export * from "./ReviewRetireMergeConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ReviewRetireMergeConfirmation.vue?vue&type=style&index=0&id=55bfa3a0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bfa3a0",
  null
  
)

export default component.exports